export default __webpack_public_path__ + "static/media/opensea.fbbd3e38.svg";